import React from "react";
import LeftIcon from "../assets/LeftIcon.svg";
import RightIcon from "../assets/RightIcon.svg";
import NewChat from "../assets/NewChat.svg";
// import ChatHistory from "../assets/ChatHistory.svg";
import Kshema from "../assets/Kshema.svg";
import K from "../assets/KIcon.svg";
import "./Sidebar.css";

interface SidebarProps {
  isOpen: boolean;

  toggleSidebar: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, toggleSidebar }) => {
  const [showConfirmModal, setShowConfirmModal] = React.useState(false);

  return (
    <div
      className={` bg-white shadow-lg p-4 transition-all ${
        isOpen ? "w-264" : "w-104"
      }`}
      style={{ borderTopRightRadius: "40px", borderBottomRightRadius: "40px" }}
    >
      <div className="flex items-center justify-between gap-[10px] mt-3">
        <div onClick={toggleSidebar}
          className={`transition-all sidebar-logo-bg `}
          //   onClick={toggleSidebar}
        >
          {isOpen ? (
            <img src={Kshema} alt="Left Icon" className="kshema-logo" />
          ) : (
            <img src={K} alt="Left Icon" className="k-logo" />
          )}
        </div>
        <button className="toggle-btn" onClick={toggleSidebar}>
          {isOpen ? (
            <img src={LeftIcon} alt="Left Icon" />
          ) : (
            <img src={RightIcon} alt="Right Icon" />
          )}
        </button>
      </div>
      <div className="mt-12">
      {isOpen ? (
           <button
           onClick={() => setShowConfirmModal(true)}
           className="flex items-center space-x-2 p-2 bg-blue-100 rounded-lg mb-2"
           style={{ margin: "16px",width:"200px" }}
         >
           <img src={NewChat} alt="Left Icon" className="text-blue-600" />
           {isOpen && <span>New Chat</span>}
         </button>
      ) : (
        <button
           onClick={() => setShowConfirmModal(true)}
           className="flex items-center space-x-2 p-2 bg-blue-100 rounded-lg mb-2"
           style={{ margin: "16px" }}
         >
           <img src={NewChat} alt="Left Icon" className="text-blue-600" />
           {isOpen && <span>New Chat</span>}
         </button>
      ) }
   

        {/* <div className="relative">
<button className="flex items-center space-x-2 p-2 rounded-lg mb-2 hover:bg-gray-200" style={{"margin":"16px"}}>
<img src={ChatHistory} alt="Left Icon" className="text-blue-600" />
            {isOpen && <span>Chat History</span>}
</button>
</div> */}
        {/* <Link
          to="/guidelines"
          className="flex items-center space-x-2 p-2 mb-2 rounded-lg hover:bg-gray-200 mt-20"
          style={{ marginLeft: "16px", marginRight: "16px" }}
        >
          <span>📄</span>

          {isOpen && <span>Guidelines</span>}
        </Link> */}
      </div>
      {showConfirmModal && (
<div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-10">
<div className="bg-white w-full max-w-md rounded-3xl shadow-lg p-[40px] relative">
  {/* Close Button */}
  <button
    onClick={() => setShowConfirmModal(false)}
    className="absolute top-3  right-5 text-gray-500 hover:text-gray-700 text-xl"
  >
    &times;
  </button>
<div>

  {/* Modal Title */}
  <h2 className="text-lg font-semibold mb-2">
    Sure about starting a new chat ?
  </h2>

  {/* Modal Body */}
  <p className="text-sm text-gray-700 mb-6">
    Starting a new chat will <strong>clear your current chat.</strong>
  </p>

  {/* Actions */}
  <div className="flex justify-center items-center gap-[15px]">
    <button
      onClick={() => setShowConfirmModal(false)}
      className="cancel-btn"
      style={{padding:"10px 30px"}}
    >
      No, stay on this
    </button>
    <button
      onClick={() => {
                  setShowConfirmModal(false);
                  window.location.reload();
                }}
      className="save-btn"
      style={{padding:"11px 70px", margin:"0px"}}

    >
      Yes
    </button>
  </div>
</div>
</div>
</div>
)}
    </div>
  );
};

export default Sidebar;